import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';

import type { SalaryValues } from '../types';

export const getSalaryFromLead = (lead?: SchemaLoanRequestResolver_Get): SalaryValues => {
    if (!lead) {
        return {
            lastMonthSalaryApplicant1: null,
            lastMonthSalaryApplicant2: null,
            salary1MonthAgoApplicant1: null,
            salary1MonthAgoApplicant2: null,
            salary2MonthAgoApplicant1: null,
            salary2MonthAgoApplicant2: null,
        };
    }
    let lastMonthSalaryApplicant1: number | null | undefined;
    let salary1MonthAgoApplicant1: number | null | undefined;
    let salary2MonthAgoApplicant1: number | null | undefined;
    if (lead.antragsteller1.beschaeftigung?.beschaeftigungsart === 'ANGESTELLTER') {
        lastMonthSalaryApplicant1 =
            lead.antragsteller1.beschaeftigung.angestellter?.beschaeftigungsverhaeltnis.nettoeinkommenMonatlich;
        salary1MonthAgoApplicant1 =
            lead.antragsteller1.beschaeftigung.angestellter?.beschaeftigungsverhaeltnis.nettoeinkommenVorletzterMonat;
        salary2MonthAgoApplicant1 =
            lead.antragsteller1.beschaeftigung.angestellter?.beschaeftigungsverhaeltnis
                .nettoeinkommenVorVorletzterMonat;
    }
    if (lead.antragsteller1.beschaeftigung?.beschaeftigungsart === 'ARBEITER') {
        lastMonthSalaryApplicant1 =
            lead.antragsteller1.beschaeftigung.arbeiter?.beschaeftigungsverhaeltnis.nettoeinkommenMonatlich;
        salary1MonthAgoApplicant1 =
            lead.antragsteller1.beschaeftigung.arbeiter?.beschaeftigungsverhaeltnis.nettoeinkommenVorletzterMonat;
        salary2MonthAgoApplicant1 =
            lead.antragsteller1.beschaeftigung.arbeiter?.beschaeftigungsverhaeltnis.nettoeinkommenVorVorletzterMonat;
    }
    if (lead.antragsteller1.beschaeftigung?.beschaeftigungsart === 'BEAMTER') {
        lastMonthSalaryApplicant1 =
            lead.antragsteller1.beschaeftigung.beamter?.beschaeftigungsverhaeltnis.nettoeinkommenMonatlich;
        salary1MonthAgoApplicant1 =
            lead.antragsteller1.beschaeftigung.beamter?.beschaeftigungsverhaeltnis.nettoeinkommenVorletzterMonat;
        salary2MonthAgoApplicant1 =
            lead.antragsteller1.beschaeftigung.beamter?.beschaeftigungsverhaeltnis.nettoeinkommenVorVorletzterMonat;
    }
    if (lead.antragsteller1.beschaeftigung?.beschaeftigungsart === 'FREIBERUFLER') {
        lastMonthSalaryApplicant1 =
            (lead.antragsteller1.beschaeftigung.freiberufler?.nettoeinkommenJaehrlich ?? 0) / 12;
    }
    if (lead.antragsteller1.beschaeftigung?.beschaeftigungsart === 'SELBSTSTAENDIGER') {
        lastMonthSalaryApplicant1 =
            (lead.antragsteller1.beschaeftigung.selbststaendiger?.nettoeinkommenJaehrlich ?? 0) / 12;
    }
    if (lead.antragsteller1.beschaeftigung?.beschaeftigungsart === 'RENTNER') {
        lastMonthSalaryApplicant1 = lead.antragsteller1.beschaeftigung.rentner?.staatlicheRenteMonatlich;
        salary1MonthAgoApplicant1 = lead.antragsteller1.beschaeftigung.rentner?.staatlicheRenteMonatlich;
        salary2MonthAgoApplicant1 = lead.antragsteller1.beschaeftigung.rentner?.staatlicheRenteMonatlich;
    }
    if (lead.antragsteller1.beschaeftigung?.beschaeftigungsart === 'HAUSFRAU') {
        lastMonthSalaryApplicant1 = lead.antragsteller1.beschaeftigung.hausfrau?.sonstigesEinkommenMonatlich;
        salary1MonthAgoApplicant1 = lead.antragsteller1.beschaeftigung.hausfrau?.sonstigesEinkommenMonatlich;
        salary2MonthAgoApplicant1 = lead.antragsteller1.beschaeftigung.hausfrau?.sonstigesEinkommenMonatlich;
    }
    if (lead.antragsteller1.beschaeftigung?.beschaeftigungsart === 'ARBEITSLOSER') {
        lastMonthSalaryApplicant1 = lead.antragsteller1.beschaeftigung.arbeitsloser?.sonstigesEinkommenMonatlich;
        salary1MonthAgoApplicant1 = lead.antragsteller1.beschaeftigung.arbeitsloser?.sonstigesEinkommenMonatlich;
        salary2MonthAgoApplicant1 = lead.antragsteller1.beschaeftigung.arbeitsloser?.sonstigesEinkommenMonatlich;
    }

    let lastMonthSalaryApplicant2: number | null | undefined;
    let salary1MonthAgoApplicant2: number | null | undefined;
    let salary2MonthAgoApplicant2: number | null | undefined;
    if (lead.antragsteller2?.beschaeftigung?.beschaeftigungsart === 'ANGESTELLTER') {
        lastMonthSalaryApplicant2 =
            lead.antragsteller2.beschaeftigung.angestellter?.beschaeftigungsverhaeltnis.nettoeinkommenMonatlich;
        salary1MonthAgoApplicant2 =
            lead.antragsteller2.beschaeftigung.angestellter?.beschaeftigungsverhaeltnis.nettoeinkommenVorletzterMonat;
        salary2MonthAgoApplicant2 =
            lead.antragsteller2.beschaeftigung.angestellter?.beschaeftigungsverhaeltnis
                .nettoeinkommenVorVorletzterMonat;
    }
    if (lead.antragsteller2?.beschaeftigung?.beschaeftigungsart === 'ARBEITER') {
        lastMonthSalaryApplicant2 =
            lead.antragsteller2.beschaeftigung.arbeiter?.beschaeftigungsverhaeltnis.nettoeinkommenMonatlich;
        salary1MonthAgoApplicant2 =
            lead.antragsteller2.beschaeftigung.arbeiter?.beschaeftigungsverhaeltnis.nettoeinkommenVorletzterMonat;
        salary2MonthAgoApplicant2 =
            lead.antragsteller2.beschaeftigung.arbeiter?.beschaeftigungsverhaeltnis.nettoeinkommenVorVorletzterMonat;
    }
    if (lead.antragsteller2?.beschaeftigung?.beschaeftigungsart === 'BEAMTER') {
        lastMonthSalaryApplicant2 =
            lead.antragsteller2.beschaeftigung.beamter?.beschaeftigungsverhaeltnis.nettoeinkommenMonatlich;
        salary1MonthAgoApplicant2 =
            lead.antragsteller2.beschaeftigung.beamter?.beschaeftigungsverhaeltnis.nettoeinkommenVorletzterMonat;
        salary2MonthAgoApplicant2 =
            lead.antragsteller2.beschaeftigung.beamter?.beschaeftigungsverhaeltnis.nettoeinkommenVorVorletzterMonat;
    }
    if (lead.antragsteller2?.beschaeftigung?.beschaeftigungsart === 'FREIBERUFLER') {
        lastMonthSalaryApplicant2 =
            (lead.antragsteller2.beschaeftigung.freiberufler?.nettoeinkommenJaehrlich ?? 0) / 12;
    }
    if (lead.antragsteller2?.beschaeftigung?.beschaeftigungsart === 'SELBSTSTAENDIGER') {
        lastMonthSalaryApplicant2 =
            (lead.antragsteller2.beschaeftigung.selbststaendiger?.nettoeinkommenJaehrlich ?? 0) / 12;
    }
    if (lead.antragsteller2?.beschaeftigung?.beschaeftigungsart === 'RENTNER') {
        lastMonthSalaryApplicant2 = lead.antragsteller2.beschaeftigung.rentner?.staatlicheRenteMonatlich;
        salary1MonthAgoApplicant2 = lead.antragsteller2.beschaeftigung.rentner?.staatlicheRenteMonatlich;
        salary2MonthAgoApplicant2 = lead.antragsteller2.beschaeftigung.rentner?.staatlicheRenteMonatlich;
    }
    if (lead.antragsteller2?.beschaeftigung?.beschaeftigungsart === 'HAUSFRAU') {
        lastMonthSalaryApplicant2 = lead.antragsteller2.beschaeftigung.hausfrau?.sonstigesEinkommenMonatlich;
        salary1MonthAgoApplicant2 = lead.antragsteller2.beschaeftigung.hausfrau?.sonstigesEinkommenMonatlich;
        salary2MonthAgoApplicant2 = lead.antragsteller2.beschaeftigung.hausfrau?.sonstigesEinkommenMonatlich;
    }
    if (lead.antragsteller2?.beschaeftigung?.beschaeftigungsart === 'ARBEITSLOSER') {
        lastMonthSalaryApplicant2 = lead.antragsteller2.beschaeftigung.arbeitsloser?.sonstigesEinkommenMonatlich;
        salary1MonthAgoApplicant2 = lead.antragsteller2.beschaeftigung.arbeitsloser?.sonstigesEinkommenMonatlich;
        salary2MonthAgoApplicant2 = lead.antragsteller2.beschaeftigung.arbeitsloser?.sonstigesEinkommenMonatlich;
    }

    return {
        lastMonthSalaryApplicant1,
        lastMonthSalaryApplicant2,
        salary1MonthAgoApplicant1,
        salary1MonthAgoApplicant2,
        salary2MonthAgoApplicant1,
        salary2MonthAgoApplicant2,
    };
};
